import type {
  VerificationCoverage,
  VerificationMissingReason,
  VerificationTitle
} from '@/Network/Types/Responses/CheckVerificationResponses'

export type VerificationButtonState = 'BIOMETRY' | 'LOCATION' | 'NONE'

export const VERIFICATION_COLUMN_HEADER = 'Local e biometria'

export const VERIFICATION_BUTTON_LABELS: Record<VerificationButtonState, string> = {
  BIOMETRY: 'Ver biometria e mapa',
  LOCATION: 'Ver mapa',
  NONE: 'Sem verificação'
}

export const VERIFICATION_MODAL_TITLES: Record<VerificationTitle, string> = {
  BIOMETRY_AND_LOCATION: 'Biometria e localização',
  LOCATION: 'Localização do registro'
}

export const VERIFICATION_COVERAGE_LABELS: Record<VerificationCoverage, string> = {
  BOTH: 'Check-in e Check-out',
  CHECKIN_ONLY: 'Somente Check-in',
  CHECKOUT_ONLY: 'Somente Check-out',
  NONE: 'Sem registro'
}

export const VERIFICATION_MISSING_REASON_LABELS: Record<VerificationMissingReason, string> = {
  NOT_REGISTERED: 'Check-out não registrado',
  NO_PHOTO: 'Sem foto de biometria',
  AUTO_PERMANENCE: 'Check-out automático por permanência'
}

export const VERIFICATION_PHOTO_RESTRICTED_TITLE = 'Foto restrita'
export const VERIFICATION_PHOTO_RESTRICTED_TEXT =
  'Seu perfil não tem acesso às fotos de biometria desta escala.'
export const VERIFICATION_DISTANCE_ESTIMATED_LABEL = 'estimada'
